<div class="migration-banner" [class.expired]="expired">
  <span class="message">
    <i class="fas fa-exclamation-triangle"></i>
    <ng-container *ngIf="!expired">
      Hệ thống này sẽ <b>ngừng nhận đơn mới</b> sau 2 ngày. Mời mọi người chuyển sang hệ thống mới để làm việc.
    </ng-container>
    <ng-container *ngIf="expired">
      Hệ thống này <b>đã ngừng nhận đơn mới</b>. Vui lòng làm việc trên hệ thống mới.
    </ng-container>
  </span>
  <span class="countdown" *ngIf="!expired">
    Còn lại:
    <b>{{days}}</b> ngày <b>{{hours}}</b>:<b>{{minutes}}</b>:<b>{{seconds}}</b>
  </span>
  <a *ngIf="newSystemUrl" class="btn btn-sm btn-light" [href]="newSystemUrl" target="_blank" rel="noopener">
    Sang hệ thống mới
  </a>
</div>
